<template lang="html">
	<div v-if="render" class="bigMenu">
		<div class="row">
			<div class="cols s_24 l_8">
				<ul>
					<li v-for="(item,index) in api_response.items" @mouseenter="activeLevel1">
						<template v-if="versionMob" @click="activeLevel1">
							<div class="wrap"
								v-if="item.submenu"
								@click="blockLink($event,index), clickShowL2($event,index)">
									<a :href="item.href"
									>
									{{item.name}}
									<span class="nextLevel">
										<svg  viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
											<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
											<path d="M0-.25h24v24H0z" fill="none"/>
										</svg>
									</span>
								</a>
							</div>
							<a v-else :href="item.href"
								@click="clickShowL2($event,index)">
								{{item.name}}
							</a>
						</template>
						<template v-else>
							<a v-if="item.submenu"
								:href="item.href"
								@mouseenter="hoverLevel1($event,index)">
								{{item.name}}
								<span class="nextLevel">
									<svg  viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
										<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
										<path d="M0-.25h24v24H0z" fill="none"/>
									</svg>
								</span>
							</a>
							<a v-else
								:href="item.href"
								@mouseenter="hoverLevel1($event,index)">
								{{item.name}}
							</a>
						</template>

						<ul class="List_L2"  v-if="versionMob">
							<li v-for="(item2,index) in item.submenu">
								<template>
									<div v-if="item2.submenu"
										@click="blockLink($event,index), clickShowL2($event,index)"
										class="wrap">
										<a class="level2Span"
											@click="clickShowL2($event,index)"
											:href="item2.href">
											{{item2.name}}
											<span class="nextLevel">
												<svg  viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
													<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
													<path d="M0-.25h24v24H0z" fill="none"/>
												</svg>
											</span>
										</a>
									</div>
									<a v-else
										@click="clickShowL2($event,index)"
										:href="item2.href">
										{{item2.name}}
									</a>
								</template>
								<ul v-if="item2.submenu">
									<li v-for="(item3,index) in item2.submenu">
										<a :href="item3.href">{{item3.name}}</a>
									</li>
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</div>

			<transition name="fade">
				<div v-if="!versionMob && showL2" class="cols s_8">
					<ul>
						<li v-for="(item,index) in level2" @mouseenter="activeLevel1">
							<template >
								<a v-if="item.submenu"
								 :href="item.href"
									@mouseenter="hoverLevel2($event,index)">
									{{item.name}}
									<span class="nextLevel">
										<svg  viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
											<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
											<path d="M0-.25h24v24H0z" fill="none"/>
										</svg>
									</span>
								</a>
								<a v-else :href="item.href"
									@mouseenter="hoverLevel2($event,index)">
									{{item.name}}
								</a>
							</template>
						</li>
					</ul>
				</div>
			</transition>

			<transition name="fade">
				<div v-if="!versionMob && showL3" class="cols s_8">
					<ul>
						<li v-for="(item,index) in level3" @mouseenter="activeLevel1">
							<a :href="item.href">
								{{item.name}}
							</a>
						</li>
					</ul>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
exports.default = {
	props: {
		dataParams: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			api_response: {},

			ww: window.innerWidth,

			render: false,

			showL2 : false,
			showL3 : false,

			indexL2: Number,
			nblockLink: false,

			level2 : [],
			level3 : []
		}
	},
	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		},
		versionMob(){
			if(this.ww < 1180) {
				console.log('versionMob true');
				return true;
			} else {
				console.log('versionMob false');
				return false
			}
		}
	},

	methods: {
		hoverLevel1($event,index) {
			this.level2 = [];
			this.level3 = [];

			this.showL3 = false;

			if(this.api_response.items[index].submenu){

				let items = this.api_response.items[index].submenu;

				this.level2 = items;
				this.indexL2 = index;
				this.showL2 = true;

			} else {

				this.showL2 = false;

			}

		},

		hoverLevel2($event,index) {
			this.level3 = [];

			if(this.api_response.items[this.indexL2].submenu[index].submenu){

				let items = this.api_response.items[this.indexL2].submenu[index].submenu;


				this.level3 = items;
				this.showL3 = true;

			} else {

				this.showL3 = false;

			}

		},

		clickShowL2($event,index){
			if($event.target.nextElementSibling){
				$event.target.nextElementSibling.classList.toggle('active');
			}
		},

		blockLink($event,index){
			if($($event.target).hasClass('blockLink')){
				$($event.target).removeClass('blockLink');
			}else {
				$($event.target).closest('ul').find('.blockLink').each(function() {
					$(this).removeClass('blockLink');
				});
				$($event.target).addClass('blockLink')
			}
		},

		activeLevel1(e){
			$(e.target).closest('ul').find('li').each(function() {
				$(this).removeClass('activeLevel');
			});
			$(e.target).addClass('activeLevel');
		}
	},
	mounted(){
		window.addEventListener('resize',() => {
			this.ww = window.innerWidth;
		});

		$(document).on('testMenu', () => {
			this.showL2 = false;
			this.showL3 = false;
			$('.activeLevel').removeClass('activeLevel');
		});

		$(document).on('renderMenu', () => {
			this.render = true;
		});
	},

	beforeMount() {
		let method = this.componentParams.method;
		let url = this.componentParams.url;
		let custom_request = this.componentParams.request;

		let options = {
			responseType: 'json'
		}

		if(method.toLowerCase() == 'post') {
			// options.params = custom_request;
			// options.body = custom_request;
			options.emulateJSON = true;
			console.log(options);
			this.$http[method](url, custom_request, options).then(success).catch(error);
		}
		else if(method.toLowerCase() == 'get') {
			options.params = custom_request;
			this.$http[method](url, options).then(success).catch(error);
		}

		function success(response) {
			console.log(response);
			this.api_response = response.body.api_response;
		}

		function error(err) {
			console.log(err);
		}
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";
	.bigMenu{
		li{
			position: relative;
			@include l_up{
				padding: 0 25px;
				&:hover{
					background-color: #f7f8fd;
				}
				&.activeLevel{
					font-weight: bold;
					a{
						font-weight: bold;
					}
					svg{
						fill: #006eb6;
					}
				}
			}
			.nextLevel{
				svg{
					position: absolute;
					right: 10px;
					top: 11px;
					width: 16px;
					height: 16px;
					fill: #a1a1ac;
				}
			}
			&:hover{
				svg{
					fill: #006eb6;
				}
			}
		}
		> div {
			> div {
				>ul{
					background: #fff;
					border-radius:  3px;
					padding: 27px 15px 21px;
					box-shadow: 0px 1px 4px #f2f2f2;
					> li {
						font-size: rem(14);
						line-height: rem(18);
						color: #393d4c;
						font-weight: 600;
						// @include l_up{
						// 	padding-top: 10px;
						// 	padding-bottom: 10px;
						// }
					}
					.wrap{
						cursor: pointer;
						a{
							pointer-events: none;
						}
						&.blockLink{
							a{
								pointer-events: auto;
							}
						}
					}
					.level1Span, .level2Span, a{
						cursor: pointer;
						display: block;
						padding: 10px 25px;
						@include l_up{
							padding: 10px 0;
						}
						&.active{
							font-weight: bold;
						}
						&:hover{
							text-decoration: none;
							background-color: #f7f8fd;
							@include m_up{
								background-color: transparent;
							}
						}
					}
					a {
						font-size: rem(14);
						font-weight: 600;
						color: #393d4c;
					}
				}
			}
		}
		.List_L2{
			display: none;
			@include m_up{
				padding-left: 15px;
			}
			li{
				a, span{
					padding-top: 10px!important;
					padding-bottom: 10px!important;
					@media(max-width: 639px){
						padding-left: 30px!important;
					}
					@media (min-width: 640px) and (max-width: 1179px){
						padding-left: 25px!important;
					}
				}
			}
			@include l_up{
				padding-left: 0;
				li{
					padding: 0;
					a, span{
						padding-left: 0;
					}
				}
			}
			> li > ul {
				display: none;
				@media (max-width: 1179px){
					a, span{
						padding-left: 40px!important;
					}
				}
				@include l_up{
					padding-left: 0;
					box-shadow: 0px 1px 4px #f2f2f2;
				}
				&.active{
					display: block;
				}
			}
			&.active {
				display: block;
			}
		}
		.fade-enter-active, .fade-leave-active {
		  transition: opacity .5s;
		}
		.fade-enter, .fade-leave-to {
		  opacity: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// BigMenu.vue?4bc8ccf4